import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

// Curated Malayalam translations for the edition's static UI text.
// Navigation tabs are intentionally NOT translated (kept in English by design).
const DICT = {
  "The Home of Malayalam Cinema": "മലയാള സിനിമയുടെ ഭവനം",
  "An IndiasCinema.com Network Edition": "ഒരു IndiasCinema.com ശൃംഖലാ പതിപ്പ്",
  "Celebrating": "ആഘോഷിക്കുന്നു",
  "Malayalam Cinema": "മലയാള സിനിമ",
  "Celebrating Malayalam Cinema": "മലയാള സിനിമയെ ആഘോഷിക്കുന്നു",
  "Movies": "സിനിമകൾ",
  "Music": "സംഗീതം",
  "People": "വ്യക്തികൾ",
  "History": "ചരിത്രം",
  "Television": "ടെലിവിഷൻ",
  "OTT": "ഒ.ടി.ടി",
  "Explore Movies": "സിനിമകൾ കാണുക",
  "Discover the Archive": "ആർക്കൈവ് കണ്ടെത്തുക",
  "NOW SHOWING": "ഇപ്പോൾ പ്രദർശനത്തിൽ",
  "What's in theatres now across Kerala": "കേരളത്തിലുടനീളം ഇപ്പോൾ തിയേറ്ററുകളിൽ",
  "LATEST NEWS": "പുതിയ വാർത്തകൾ",
  "Latest updates from the world of Malayalam cinema": "മലയാള സിനിമാ ലോകത്തുനിന്നുള്ള പുതിയ വിശേഷങ്ങൾ",
  "MEET THE STAR": "താരങ്ങളെ പരിചയപ്പെടാം",
  "Profiles, journeys and stories of cinema personalities": "സിനിമാ വ്യക്തിത്വങ്ങളുടെ പ്രൊഫൈലുകളും യാത്രകളും കഥകളും",
  "FROM THE ARCHIVE": "ആർക്കൈവിൽ നിന്ന്",
  "Rare photos, articles and timeless treasures": "അപൂർവ്വ ചിത്രങ്ങൾ, ലേഖനങ്ങൾ, കാലാതീത നിധികൾ",
  "Upcoming Movies": "വരാനിരിക്കുന്ന സിനിമകൾ",
  "Interviews": "അഭിമുഖങ്ങൾ",
  "Cinema History": "സിനിമാ ചരിത്രം",
  "Memories": "ഓർമ്മകൾ",
  "View All": "എല്ലാം കാണുക",
  "Celebrating the people, music and history of Malayalam cinema.": "മലയാള സിനിമയുടെ വ്യക്തികളെയും സംഗീതത്തെയും ചരിത്രത്തെയും ആഘോഷിക്കുന്നു.",
  // Section pages
  "Malayalam Movies": "മലയാള സിനിമകൾ",
  "Now playing, upcoming releases and the complete film archive.": "ഇപ്പോൾ പ്രദർശനത്തിലുള്ളവ, വരാനിരിക്കുന്നവ, സമ്പൂർണ്ണ ചലച്ചിത്ര ആർക്കൈവ്.",
  "Meet the Star": "താരങ്ങളെ പരിചയപ്പെടാം",
  "Profiles of actors, directors, musicians and the many artists of Mollywood.": "മോളിവുഡിലെ അഭിനേതാക്കൾ, സംവിധായകർ, സംഗീതജ്ഞർ എന്നിവരുടെ പ്രൊഫൈലുകൾ.",
  "Conversations with the people who shape Malayalam cinema.": "മലയാള സിനിമയെ രൂപപ്പെടുത്തുന്നവരുമായുള്ള സംഭാഷണങ്ങൾ.",
  "The story of Malayalam cinema — from the early talkies to the OTT era.": "മലയാള സിനിമയുടെ കഥ — ആദ്യകാല ശബ്ദചിത്രങ്ങൾ മുതൽ ഒ.ടി.ടി യുഗം വരെ.",
  "Tributes and remembrances of the artists we have lost.": "നമുക്ക് നഷ്ടപ്പെട്ട കലാകാരന്മാരുടെ ഓർമ്മകളും ആദരാഞ്ജലികളും.",
  "Photographs, events, posters and captioned collections.": "ചിത്രങ്ങൾ, പരിപാടികൾ, പോസ്റ്ററുകൾ, അടിക്കുറിപ്പോടുകൂടിയ ശേഖരങ്ങൾ.",
  "About AMMA": "അമ്മയെക്കുറിച്ച്",
  "Association of Malayalam Movie Artists — historical archive and information.": "അസോസിയേഷൻ ഓഫ് മലയാളം മൂവി ആർട്ടിസ്റ്റ്സ് — ചരിത്ര ആർക്കൈവും വിവരങ്ങളും.",
  "Star Address": "താര വിലാസം",
  "Professional and representation contacts for the industry.": "വ്യവസായത്തിനായുള്ള പ്രൊഫഷണൽ, പ്രാതിനിധ്യ ബന്ധപ്പെടലുകൾ.",
  "Content from the archive will appear here as it is migrated and reviewed.": "ആർക്കൈവിൽ നിന്നുള്ള ഉള്ളടക്കം പരിശോധിച്ച ശേഷം ഇവിടെ ദൃശ്യമാകും.",
  "Explore": "കൂടുതൽ",
  "Listen": "കേൾക്കുക",
  "Pause": "നിർത്തുക",
  "Loading": "ലോഡ് ചെയ്യുന്നു",
  "Discussion": "ചർച്ച",
  "Galleries": "ഗാലറികൾ",
  "Photographs, events, posters and captioned collections from the archive and our team.": "ആർക്കൈവിൽ നിന്നും ഞങ്ങളുടെ ടീമിൽ നിന്നുമുള്ള ചിത്രങ്ങളും പരിപാടികളും പോസ്റ്ററുകളും അടിക്കുറിപ്പുള്ള ശേഖരങ്ങളും.",
  "No photos have been added to the gallery yet.": "ഗാലറിയിലേക്ക് ഇതുവരെ ചിത്രങ്ങളൊന്നും ചേർത്തിട്ടില്ല.",
};

const Ctx = createContext(null);

export const MalayalamLangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("ml_edition_lang") || "en");
  useEffect(() => { localStorage.setItem("ml_edition_lang", lang); }, [lang]);
  const setLang = useCallback((l) => setLangState(l), []);
  const t = useCallback((s) => (lang === "ml" && DICT[s]) ? DICT[s] : s, [lang]);
  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
};

export const useMalayalamLang = () => {
  const v = useContext(Ctx);
  return v || { lang: "en", setLang: () => {}, t: (s) => s };
};
